<script>
/**
 * OwalList.vue
 *
 * @description Displays a list of items.
 *
 * @prop {Array} items The items to display.
 * @prop {Boolean} multiselect Sets the ability to select multiple items.
 * @prop {Function} callback A function to call when the selection changes.
 *
 */

import { toggle } from '@/libraries/util/array'
import OwalListSection from './OwalListSection'
import OwalListRow from './OwalListRow'

export default {
  name: 'OwalList',
  components: {
    OwalListSection,
    OwalListRow,
  },
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    multiselect: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      default: undefined,
    },
  },
  data () {
    return {
      selectedIndices: [],
    }
  },
  computed: {
    sectionsToRender () {
      let sections = this.sections
      if (this.items && this.items.length > 0) {
        sections = [{
          title: '',
          items: this.items,
        }]
      }
      return sections
    },
  },
  methods: {
    toggleItem (item) {
      const index = this.items.indexOf(item)

      this.selectedIndices = toggle(this.selectedIndices, index)

      if (this.callback) {
        this.callback(this.selectedIndices.map(index => this.items[index]))
      }
    },
  },
}
</script>

<template>
  <div>
    <owal-list-section
      v-for="section in this.sectionsToRender"
      :key="section.identifier"
      :items="section.items"
      :title="section.title"
    >
      <div
        slot-scope="item"
      >
        <owal-list-row
          :item="item"
        >
          <slot
            v-bind="item"
          />
        </owal-list-row>
      </div>
    </owal-list-section>
  </div>
</template>

<style scoped>

</style>
